exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-4575e287] {\n  width: 100%;\n}\nth[data-v-4575e287]{\n  border: solid 1px #e8e8e8;\n}\ntd[data-v-4575e287]{\n  border: solid 1px #e8e8e8;\n}\n.btnWrap[data-v-4575e287] {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n@media screen and (max-width: 575px) {\n.width-140[data-v-4575e287]{\n      width: initial;\n}\n.contactForm td[data-v-4575e287]{\n      border: none;\n}\n}\n", ""]);

// exports
